import GridWithBackground from './GridWithBackground'

export default GridWithBackground
// eslint-disable-next-line import/export
export * from './GridWithBackground'
